import eventWaitlistController from './eventWaitlistController'

export default eventWaitlistController



// WEBPACK FOOTER //
// ../src/controllers/eventWaitlistController/index.js